import { render } from "./Upjang.vue?vue&type=template&id=7eda4542"
import script from "./Upjang.vue?vue&type=script&lang=js"
export * from "./Upjang.vue?vue&type=script&lang=js"

import exportComponent from "F:\\stsworkspace\\gil\\yongpyong-mobile-service-main\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__